<template>
  <div>
    <file-link
      :fileUrl="fileUrl"
      :iconSrc="iconSrc"
      :text="linkContent"
    ></file-link>
    <div class="form-group field-certListBox">
      <certificates-list-box
        selectClass="form-control"
        :externalInfo="externalInfo"
        :stringConstructor="stringConstructor"
        @certificate-selected="onSelectChange"
      />
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import CertificatesListBox from '@/common/components/CertificatesListBox'
import { Logger } from '@/common/helpers/Logger'
import { CertificateObj } from '@/common/helpers/signer/certificates'
import { CertificatesStringConstructor } from '@/common/helpers/signer/certificatesStringConstructor'
import { SignApi } from '../../classes/SignApi'
import { Signer } from '../../classes/Signer'
import { UpdateDTO } from '../../classes/dto/UpdateDTO'
import FileLink from '../../components/sign-widget/FileLink'
import WidgetButtonsEnum from '../../enums/WidgetButtonsEnum'

export default {
  name: 'SignWidget',

  components: {
    FileLink,
    CertificatesListBox
  },

  props: {
    api: {
      type: Object,
      default: function () {
        return new SignApi(this.$route.query.token);
      }
    },
    modalTitle: {
      type: String,
      default: 'Электронная подпись'
    },
    mediator: {
      type: Object,
      required: true
    },
    successRoute: {
      type: String
    },
    unsuccessRoute: {
      type: String
    }
  },

  data: () => ({
    certificate: null,
    externalInfo: '',
    formSending: false,
    fileUrl: '',
    linkContent: '',
    iconSrc: '',
    stringConstructor: new CertificatesStringConstructor({
      constructArray: [
        CertificatesStringConstructor.getSubjectOrganization,
        ', ',
        CertificatesStringConstructor.getSurname,
        ' ',
        CertificatesStringConstructor.getGeneralName
      ]
    }),
    unsuccessMessage: 'При подписании возникла ошибка'
  }),

  computed: {
    status () {
      return true
    },

    successMessage () {
      return 'Заявка подписана'
    },

    canSign () {
      return !this.formSending && this.user
    }
  },

  methods: {
    async submitSignModal () {
      if (!this.canSign) {
        return false
      }

      await this.formSetSending()
      try {
        if (!await this.isValid()) {
          this.$router.push(this.unsuccessRoute || '/tsp/sign-widget/error')
          await this.formSetSent()

          return false
        }

        if (await this.beforeSign()) {
          let result = null
          try {
            result = await this.api.update(new UpdateDTO({}))
          } catch (error) {
            result = error.response ?? {}
          }

          this.unsuccessMessage = result.data?.message || this.unsuccessMessage
          if (result.data?.success === true) {
            await this.formSetSent()
            await this.signed()

            return true
          }
        }
      } catch (error) {
        Logger.log(error)
      }
      alert(this.unsuccessMessage)
      await this.signFailed()
      await this.formSetSent()

      return false
    },

    async beforeSign () {
      this.$emit('before-sign')

      return await this.beforeSignInner()
    },

    async signed () {
      this.$emit('signed')
      await this.signedInner()
    },

    async signFailed () {
      this.$emit('sign-failed')
      await this.signFailedInner()
    },

    async signedInner () {
      this.$router.push(this.successRoute || '/tsp/sign-widget/success')
    },

    async beforeSignInner () {
      let certificate = this.certificate
      if (!certificate) {
        this.unsuccessMessage = 'Сертификат не выбран'

        return false
      }

      let signed = true
      try {
        await new Signer({ api: this.api, certificate }).sign()
      } catch (error) {
        this.unsuccessMessage = error.message
        signed = false
      }

      return signed;
    },

    async signFailedInner () {
    },

    async isValid () {
      let result = null
      try {
        result = await this.api.isValid()
      } catch (error) {
        result = error.result ?? { data: {} }
      }
      let isValid = result.data.isValid === true;
      if (!isValid) {
        this.unsuccessMessage = result.data.message || this.unsuccessMessage
      }

      return isValid
    },

    async formSetSending () {
      this.formSending = true
      this.mediator.setButtons([
        WidgetButtonsEnum.blockedSignAndSend
      ])
      window.addEventListener('beforeunload', this.commitExit)
    },

    async formSetSent () {
      this.formSending = false
      this.mediator.resetButtons()
      window.removeEventListener('beforeunload', this.commitExit)
    },

    commitExit (event) {
      let message = 'Заявка находится в стадии подписания. Без активного соединения мы не сможем закончить подписание, ' +
        'что может привести к проблемам с передачей заявки в следующий статус. Вы уверены, что хотите покинуть страницу?'

      event.preventDefault()
      event.returnValue = message

      return message
    },

    extractInfoFromCertificate (from, what) {
      let value = new CertificateObj().extract(from, what)
      value = value.replace(what, '')
      return value
    },

    async onSelectChange (certificate) {
      this.certificate = certificate
      if (certificate) {
        const validTo = moment(await certificate.ValidToDate)
          .locale('ru')
          .format('DD.MM.YYYY LT')
        this.externalInfo =
          'Действителен до: ' + validTo + '<br>' +
          'Издатель: ' + this.extractInfoFromCertificate(await certificate.IssuerName, 'O=') + '<br>'
      }
    }
  },

  created () {
    this.$root.$on(WidgetButtonsEnum.signAndSend.eventName, this.submitSignModal)
    this.api.constructWidget()
      .then(response => {
        let file = response.data.file ?? {}
        this.fileUrl = file.url ?? ''
        this.linkContent = file.about ?? ''
        this.iconSrc = file.icon ?? ''
      })
      .catch(Logger.log)
  }
}
</script>
